import React from "react";
import { Typography, Checkbox, Switch, Row } from "antd";
import {
  EmployeeFollowUpEventQuizStatus,
  AnsweredBy,
  QuizAnsweredBy,
  NotApplicableSuffix,
  NotApplicableLabel,
} from "../common/GeneralConfigurations";
import "./EmployeeFollowUpEventDetailListForm.css";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

const { Text, Title } = Typography;

const QuizQuestionTrueFalseForm = ({
  quizIsAnsweredBy,
  quizStatusId,
  readonly,
  answeredBy,
  questionText,
  isRequired,
  allowNotApplicable,
  errorMessage,
  fieldName,
  consultantAnswer,
  consultantAllowNotApplicableAnswer,
  supervisorAnswer,
  supervisorAllowNotApplicableAnswer,
  handleSwitchChange,
  onNotApplicable,
  isReadOnly,
  onBlur,
}) => {
  const isNotApplicable = true;

  return (
    <>
      {/* Consultant view or Supervisor view and wating for consultant answer */}
      {quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromConsultant && (
        // (answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) &&
        <div className="quiz-question-person">
          {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}

          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>

          <p className="quiz-element-margin">
            <Switch
              name={fieldName}
              label={questionText}
              checkedChildren="Yes"
              unCheckedChildren="No"
              defaultChecked={supervisorAnswer}
              checked={supervisorAnswer}
              disabled={isReadOnly(
                allowNotApplicable === true
                  ? consultantAllowNotApplicableAnswer
                  : false
              )}
              onChange={(e) => handleSwitchChange(e, fieldName)}
            />
          </p>
          {allowNotApplicable === true && (
            <p className="quiz-element-margin">
              <Checkbox
                name={fieldName + NotApplicableSuffix}
                defaultChecked={consultantAllowNotApplicableAnswer}
                checked={consultantAllowNotApplicableAnswer}
                onChange={(value) => onNotApplicable(value, fieldName)}
                disabled={readonly}
              >
                {NotApplicableLabel}
              </Checkbox>
            </p>
          )}
          {errorMessage && <Text type="danger">{errorMessage}</Text>}
        </div>
      )}
      {/* Supervisor view for regular type events, that are answered only by the supervisor */}
      {quizIsAnsweredBy === QuizAnsweredBy.Supervisor &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
        (answeredBy === AnsweredBy.Supervisor ||
          answeredBy === AnsweredBy.Both) && (
          <>
            {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}

            <Row className="question-title">
              <Text type="danger">{isRequired ? "* " : ""}</Text>
              <AdnTextArea placeholder={questionText} disabled autoSize />
            </Row>

            <p className="quiz-element-margin">
              <Switch
                name={fieldName}
                label={questionText}
                checkedChildren="Yes"
                unCheckedChildren="No"
                defaultChecked={consultantAnswer}
                checked={consultantAnswer}
                disabled={isReadOnly(
                  allowNotApplicable === true
                    ? supervisorAllowNotApplicableAnswer
                    : false
                )}
                onChange={(e) => handleSwitchChange(e, fieldName)}
              />
            </p>
            {allowNotApplicable === true && (
              <p className="quiz-element-margin">
                <Checkbox
                  name={fieldName + NotApplicableSuffix}
                  defaultChecked={supervisorAllowNotApplicableAnswer}
                  checked={supervisorAllowNotApplicableAnswer}
                  onChange={(value) => onNotApplicable(value, fieldName)}
                  disabled={readonly}
                >
                  {NotApplicableLabel}
                </Checkbox>
              </p>
            )}
            {errorMessage && <Text type="danger">{errorMessage}</Text>}
          </>
        )}
      {/* Supervisor view for evaluation type events */}
      {quizIsAnsweredBy === QuizAnsweredBy.Consultant &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor && (
          <>
            {/* consultant answer */}
            {(answeredBy === AnsweredBy.Consultant ||
              answeredBy === AnsweredBy.Both) && (
              <>
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>
                {allowNotApplicable === true &&
                consultantAllowNotApplicableAnswer === isNotApplicable ? (
                  <>
                    <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                    <p className="quiz-not-applicable">{NotApplicableLabel}</p>
                  </>
                ) : (
                  <p>
                    <b style={{ color: "var(--adnblue)" }}>
                      Consultant: &nbsp;
                    </b>
                    {consultantAnswer === true ? "Yes" : "No"}
                  </p>
                )}
              </>
            )}
            {/* supervisor answer */}
            {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
            {(answeredBy === AnsweredBy.Supervisor ||
              answeredBy === AnsweredBy.Both) && (
              <div className="quiz-question-person">
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>

                <p className="quiz-element-margin">
                  <Switch
                    name={fieldName}
                    label={questionText}
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    defaultChecked={supervisorAnswer}
                    checked={supervisorAnswer}
                    disabled={isReadOnly(
                      allowNotApplicable === true
                        ? supervisorAllowNotApplicableAnswer
                        : false
                    )}
                    onChange={(e) => handleSwitchChange(e, fieldName)}
                    onBlur={onBlur}
                  />
                </p>
                {allowNotApplicable === true && (
                  <p className="quiz-element-margin">
                    <Checkbox
                      name={fieldName + NotApplicableSuffix}
                      defaultChecked={supervisorAllowNotApplicableAnswer}
                      checked={supervisorAllowNotApplicableAnswer}
                      onChange={(value) => onNotApplicable(value, fieldName)}
                      disabled={readonly}
                    >
                      {NotApplicableLabel}
                    </Checkbox>
                  </p>
                )}
                {errorMessage && <Text type="danger">{errorMessage}</Text>}
              </div>
            )}
          </>
        )}
      {/* when quiz is answered */}
      {quizStatusId === EmployeeFollowUpEventQuizStatus.Answered && (
        <>
          {/* consultant answer */}
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>
          {(consultantAnswer === true ||
            consultantAnswer === false ||
            consultantAllowNotApplicableAnswer) && (
            <p>
              <span code strong className="answer-consultant">
                Consultant:{" "}
              </span>
              {(consultantAnswer === true || consultantAnswer === false) && (
                <Text>{consultantAnswer === true ? "Yes" : "No"}</Text>
              )}
              {consultantAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
          {/* supervisor answer */}
          {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
          {(supervisorAnswer === true ||
            supervisorAnswer === false ||
            supervisorAllowNotApplicableAnswer) && (
            <p>
              <span className="answer-supervisor">Supervisor: </span>
              {supervisorAllowNotApplicableAnswer !== isNotApplicable &&
                (supervisorAnswer === true || supervisorAnswer === false) && (
                  <Text>{supervisorAnswer === true ? "Yes" : "No"}</Text>
                )}
              {supervisorAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
        </>
      )}
    </>
  );
};

export default QuizQuestionTrueFalseForm;
